module.exports = __webpack_public_path__ + "img/header-background-zh.aeadb142.png";